export default __webpack_public_path__ + "static/media/battery-low.a171042d.svg";